// Jahr.KW.Release

// This Version gets automatically updated by the build process and so also in the GitLab-CI.
const VERSION = '2024.11.6';
const REVISION = '7ddf4556b';
module.exports = { VERSION, REVISION };